export default __webpack_public_path__ + "static/media/IconDesc_SnowDispenser.256.04f82cfa.png";